import { type ReactNode } from "react";
import classNames from "classnames";
import DetailsCardColumn from "@/components/DetailsCard/DetailsCardColumn";

export interface DetailsCardTwoColumnRowProps {
  narrowColumn: ReactNode;
  wideColumn: ReactNode;
  className?: string;
  /**
   * Adds `pt-12` (48px) above the row. Set when no `SectionHeading` sits above the grid —
   * including first under tabs and after MetricGrid or other section content.
   */
  tabBodySpacing?: boolean;
}

/**
 * One-third / two-thirds row for {@link DetailsCard} content on medium+ breakpoints.
 * Stacks on small screens with the wide column first. Null children are omitted.
 */
export default function DetailsCardTwoColumnRow({
  narrowColumn,
  wideColumn,
  className,
  tabBodySpacing = false
}: DetailsCardTwoColumnRowProps) {
  return (
    <div
      className={classNames(
        "flex flex-col-reverse md:flex-row gap-x-10 gap-y-10 min-w-0 items-stretch",
        tabBodySpacing && "pt-12",
        className
      )}
      data-testid="details-card-two-column-row"
    >
      <div className="basis-1/3 min-w-0">
        <DetailsCardColumn>{narrowColumn}</DetailsCardColumn>
      </div>
      <div className="basis-2/3 min-w-0">
        <DetailsCardColumn>{wideColumn}</DetailsCardColumn>
      </div>
    </div>
  );
}
